module.exports = __webpack_public_path__ + "media/images/top-content-img-12-821794d30cc9a1290585b6203d70eee6.jpg";